// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wallet-not-found {
  min-height: 100vh;
  min-height: 100dvh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: linear-gradient(180deg, #07131b 0%, #04080c 100%);
}

.wallet-not-found__card {
  width: min(100%, 460px);
  padding: 28px;
  border-radius: 24px;
  background: rgba(9, 17, 24, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.08);
  text-align: center;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.36);
}

.wallet-not-found__card span {
  display: inline-block;
  margin-bottom: 12px;
  color: #f0ca73;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  font-size: 0.78rem;
}

.wallet-not-found__card h1 {
  margin: 0 0 10px;
}

.wallet-not-found__card p {
  margin: 0 0 18px;
  color: rgba(233, 238, 241, 0.74);
}

.wallet-not-found__card a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  padding: 0 18px;
  border-radius: 14px;
  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);
  border: 1px solid rgba(49, 230, 164, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;EAC3C,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,6FAA6F;EAC7F,yCAAyC;AAC3C","sourcesContent":[".wallet-not-found {\n  min-height: 100vh;\n  min-height: 100dvh;\n  display: grid;\n  place-items: center;\n  padding: 24px;\n  background: linear-gradient(180deg, #07131b 0%, #04080c 100%);\n}\n\n.wallet-not-found__card {\n  width: min(100%, 460px);\n  padding: 28px;\n  border-radius: 24px;\n  background: rgba(9, 17, 24, 0.96);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  text-align: center;\n  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.36);\n}\n\n.wallet-not-found__card span {\n  display: inline-block;\n  margin-bottom: 12px;\n  color: #f0ca73;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  font-size: 0.78rem;\n}\n\n.wallet-not-found__card h1 {\n  margin: 0 0 10px;\n}\n\n.wallet-not-found__card p {\n  margin: 0 0 18px;\n  color: rgba(233, 238, 241, 0.74);\n}\n\n.wallet-not-found__card a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 48px;\n  padding: 0 18px;\n  border-radius: 14px;\n  background: linear-gradient(180deg, rgba(49, 230, 164, 0.22) 0%, rgba(16, 68, 52, 0.88) 100%);\n  border: 1px solid rgba(49, 230, 164, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
